import { Record } from 'immutable';

const keys = {
  name: '',
  code: '',
};

export interface StateFields {
  name: string;
  code: string;
}

export default class StateRecord extends Record<StateFields>(keys) {}
